import PropTypes from 'prop-types';
import React, { Component } from 'react';
export class SubTabs extends Component {
    static propTypes = {
        tabs: PropTypes.array
    };
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "0",
            renderedIds: []
        };
        this.setActiveTab = this.setActiveTab.bind(this);
    }
    render() {
        const { tabs } = this.props;
        const { activeTab } = this.state;
        return (
            <>
                <div className="inboxes">
                    <ul>
                        {tabs.map((item, index) =>
                            <li key={index} className={index.toString() === activeTab ? "active" : ""} onClick={() => this.setActiveTab(index.toString())}>
                                {item.label}
                            </li>
                        )}
                    </ul>
                </div>
                {this.props.children ? this.props.children.map((item, index) =>
                    <div key={index} style={(index.toString() === activeTab) ? { display: "" } : { display: "none" }}>
                        {item}
                    </div>
                ) : ""}
            </>
        );
    }
    setActiveTab(activeTab) {
        activeTab = activeTab?.toLowerCase();
        this.setState({
            activeTab: activeTab
        });
    }
}